import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Lock } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { SpecraBadge } from '../ensigns/badge';
import { specraFocusRing } from '../ensigns/focus-ring';
import { SpecraIcon } from '../ensigns/icon';
import { SpecraTooltip } from './tooltip';
/** A lock chip standing in for a value the viewer may not see. */ export function SpecraRestrictedChip({ className, icon, label, reason, ...props }) {
    const chip = /*#__PURE__*/ _jsxs(SpecraBadge, {
        className: cn('gap-[var(--space-1)] font-normal text-muted-foreground', reason && specraFocusRing, className),
        "data-restricted": "",
        tabIndex: reason ? 0 : undefined,
        variant: "outline",
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraIcon, {
                size: "sm",
                children: icon ?? /*#__PURE__*/ _jsx(Lock, {})
            }),
            label,
            /*#__PURE__*/ _jsx("span", {
                className: "sr-only",
                children: " (restricted)"
            })
        ]
    });
    return reason ? /*#__PURE__*/ _jsx(SpecraTooltip, {
        content: reason,
        children: chip
    }) : chip;
}
